const devSettings = {
  force_production: true,
};

export default devSettings;
